module.exports = __webpack_public_path__ + "img/DIRECTOR_APPROVED.fb07748e.svg";